<script>
  let token = '';

  const handleSubmit = () => {
    console.debug(token);
    localStorage.setItem('token', token);
    window.location = location;
  }
</script>

<svelte:head>
  <title>login</title>
</svelte:head>

<div>
  <form on:submit|preventDefault={handleSubmit}>
    <label>login</label>
    <input type=text bind:value={token} />
    <button type="submit" style="display: none" />
  </form>
</div>

<style>
  div {
    display: flex;
    justify-content: center;
  }
  form {
    display: flex;
    margin: 0 auto;
    flex-direction: column;
    align-items: center;
  }
  label {
    color: #bebec3;
    font-size: 18px;
    text-transform: uppercase;
    margin: 18px auto 0 auto;
  }
  input {
    background: transparent;
    border: 1px #20ffea solid;
    font-size: 22px;
    margin: 20px auto;
    border-radius: 4px;
    color: #bebec3;
    padding: 4px;
    width: 800px;
    max-width: 80vw;
    text-align: center;
  }
</style>
